module.exports = __webpack_public_path__ + "static/img/6.d59b01b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/sp/6.png
// module id = CEpB
// module chunks = 0